import { generateLabelsAndValues } from "../utils/helperFunctions";

// Route Constants start
export const BASE_URL = "/";
export const REGISTER = "register";
export const ATP_REGISTER = "/atp/register";
export const ATP_LOGIN = "/atp/login";
export const EMAIL_VERIFICATION = "email-verification";
export const ACTIVATE_ACCOUNT = "activate-account";
export const DASHBOARD = "";
export const FORGOT_PASSWORD = "/forgot-password";
export const RESET_PASSWORD = "reset-password";
export const DEACTIVATE_FORGOT_PASSWORD = "deactivate-forgot-password";
export const USER_CPD_ACTIVITIES = "cpd-activities";
export const USER_CPD_MY_ACTIVITIES = "my-activities";
export const ATP_BILLING_HISTORY = "/atp/billing";
export const ATP_SUBSCRIPTION_STATUS = "/atp/billing/subscription-status";
// Route Constants end

export const CERTIFICATES = {
    _1: "1",
    _2: "2",
};
// Activate account response codes start
export const ACTIVATE_ACCOUNT_RESPONSE_CODES = {
    LINK_EXPIRED: 10001,
    INVALID_LINK: 10002,
    ACCOUNT_NOT_FOUND: 10003,
    ACCOUNT_ALREADY_VERIFIED: 10004,
    ACCOUNT_ACTIVATED_SUCCESSFULLY: 10005,
};
// Activate account response codes end

// Type of users start
export const USERS_TYPE = {
    ADMIN: 1,
    USER: 2,
    ATP_USER: 3,
};
// Type of users end

// Type of duration start
export const durationType = {
    HOURS: 1,
    DAYS: 2,
};

export const DurationType = generateLabelsAndValues(durationType);

// Custom styles for react-select
export const colourStyles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        backgroundColor: "#F5F8FA",
        border: "none",
        boxShadow: isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "",
        color: "#464E5F",
        borderRadius: "0.375rem",
        minHeight: "44px",
    }),
    option: (styles, { isDisabled, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isSelected ? "rgba(41, 52, 143, 0.04)" : "#fff",
            color: "#464E5F",
            cursor: isDisabled ? "not-allowed" : "default",
        };
    },
    dropdownIndicator: (base) => ({
        ...base,
        color: "#212121",
    }),
};

// Custom styles for react-select for identifier number
export const colourStylesVariant = {
    control: (styles, { isFocused }) => ({
        ...styles,
        backgroundColor: "#F5F8FA",
        border: "none",
        boxShadow: isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "",
        color: "#464E5F",
        borderRadius: "0.375rem 0 0 0.375rem",
        minHeight: "44px",
    }),
    option: (styles, { isDisabled, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isSelected ? "rgba(41, 52, 143, 0.04)" : "#fff",
            color: "#464E5F",
            cursor: isDisabled ? "not-allowed" : "default",
            marginBottom: "8px",
        };
    },
    dropdownIndicator: (base) => ({
        ...base,
        color: "#212121",
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: "rgba(70, 78, 95, 0.24)",
    }),
};

// Custom styles for react-select for identifier number
export const colourStylesFullWidth = {
    control: (styles, { isFocused }) => ({
        ...styles,
        backgroundColor: "#F5F8FA",
        border: "none",
        boxShadow: isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "",
        color: "#464E5F",
        borderRadius: "0.375rem",
        minHeight: "44px",
    }),
    option: (styles, { isDisabled, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isSelected ? "rgba(41, 52, 143, 0.04)" : "#fff",
            color: "#464E5F",
            cursor: isDisabled ? "not-allowed" : "default",
            marginBottom: "8px",
            display: "flex",
            justifyContent: "start",
        };
    },
    dropdownIndicator: (base) => ({
        ...base,
        color: "#212121",
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: "rgba(70, 78, 95, 0.24)",
        display: "flex",
        justifyContent: "start",
    }),
    menu: (provided, state) => ({
        ...provided,
        zIndex: 9999,
    }),
};

export const colourStylesMultiSelect = {
    ...colourStyles,
    multiValue: (provided, { isMulti }) => ({
        ...provided,
        backgroundColor: "white", // Change background color for the multi-value container
        color: "#464E5F", // Change text color for the multi-value container
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "#464E5F", // Change text color for the label of the selected options
        borderLeft: "1px solid #C4CDD5",
        borderTop: "1px solid #C4CDD5",
        borderBottom: "1px solid #C4CDD5",
        borderTopLeftRadius: "4px",
        borderBottomLeftRadius: "4px",
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "#464E5F", // Color of the cross
        borderRight: "1px solid #C4CDD5",
        borderTop: "1px solid #C4CDD5",
        borderBottom: "1px solid #C4CDD5",
        borderTopRightRadius: "4px",
        borderBottomRightRadius: "4px",
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0",
        ":hover": {
            backgroundColor: "#f2f3f7", // Background color on hover
            color: "#464E5F", // Cross color on hover
        },
    }),
};

export const COUNTRIES = "countries";
export const STATES = "states";
export const CITIES = "cities";

export const phoneRegExp = /^\+?\d{10,15}$/;

export const SliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
            },
        },
        {
            breakpoint: 1024, // For larger screens like laptops
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
            },
        },
    ],
};

export const TIMESLOTOPTIONS = {
    "09.00 AM - 09.30 AM": 1,
    "09.30 AM - 10.00 AM": 2,
    "10.00 AM - 10.30 AM": 3,
    "10.30 AM - 11.00 AM": 4,
    "11.00 AM - 11.30 AM": 5,
    "11.30 AM - 12.00 PM": 6,
    "12.00 PM - 12.30 PM": 7,
    "02.00 PM - 02.30 PM": 8,
    "02.30 PM - 03.00 PM": 9,
    "03.00 PM - 03.30 PM": 10,
    "03.30 PM - 04.00 PM": 11,
    "04.00 PM - 04.30 PM": 12,
    "04.30 PM - 05.00 PM": 13,
    "05.00 PM - 05.30 PM": 14,
};

export const Time_Slot_Options = generateLabelsAndValues(TIMESLOTOPTIONS);

export const PaymentAmountTypes = {
    GT_QT: 50,
    TS_TC: 600,
    CERTIFICATE_RENEWAL: 200,
    ATP_PROFILE: 150,
    ASSESSMENT: 350,
    ATP_RENEWAL: 150,
};

export const PaymentOf = {
    GT_QT: "GT_QT",
    TS_TC: "TS_TC",
    CERTIFICATE_RENEWAL: "CERTIFICATE_RENEWAL",
    ATP_PROFILE: "ATP_PROFILE",
    ASSESSMENT: "ASSESSMENT",
    ATP_RENEWAL: "ATP_RENEWAL",
};

// export const MapRejectionCategory = {
//   1: 'Basic Information',
//   2: 'Academic Qualification',
//   3: 'Working Experience',
//   4: 'Assessment',
// };
export const MapRejectionCategory = {
    1: "Qualification does not fulfill minimum requirement",
    2: "Your area of expertise does not listed under the 24 fields of technology",
    3: "Work experience is irrelevant",
    4: "Not Cover Technical and Technology services",
    5: "Others - secretariat can write the reason manually",
};

export const BankNameDropList = {
    AFFIN_BANK: "Affin Bank",
    ALLIANCE_BANK_PERSONAL: "Alliance Bank (Personal)",
    AGRONET: "AGRONet",
    AMBANK: "AmBank",
    BANK_ISLAM: "Bank Islam",
    BANK_MUAMALAT: "Bank Muamalat",
    BANK_RAKYAT: "Bank Rakyat",
    BANK_OF_CHINA: "Bank Of China",
    BSN: "BSN",
    CIMB_CLICKS: "CIMB Clicks",
    HONG_LEONG_BANK: "Hong Leong Bank",
    HSBC_BANK: "HSBC Bank",
    KFH: "KFH",
    MAYBANK_2E: "Maybank2E",
    MAYBANK_2U: "Maybank2U",
    OCBC_BANK: "OCBC Bank",
    PUBLIC_BANK: "Public Bank",
    RHB_BNAK: "RHB Bank",
    STANDERD_CHARTERED: "Standard Chartered",
    UOB_BANK: "UOB Bank",
};
